import { toast } from 'react-toastify';
import { replaceOrAddById } from '../App/Helpers/store';

export const groupsInitialState = {
	loading: false,
	items: [],
};

export const groupsReducer = (state = groupsInitialState, action) => {
	switch (action.type) {
		case 'GROUPS_ADD':
		case 'GROUPS_DELETE':
			return state;

		case 'GROUPS_EDITING':
		case 'GROUPS_LOADING':
			return {
				...state,
				loading: true,
			};

		case 'GROUPS_GET':
			return {
				...state,
				loading: false,
				items: action.payload.data.data,
			};

		case 'GROUPS_ERROR':
			toast.error('Virhe tietojen tallennuksessa');
			return {
				...state,
				loading: false,
			};
		case 'GROUPS_EDITED':
			toast.success('Tiedot tallennettu');
			return {
				...state,
				loading: false,
			};

		case 'GROUP_SET_LOADING':
			let nitems = [...state.items];
			let nindex = nitems.findIndex((val) => {
				// eslint-disable-next-line eqeqeq
				return val.id == action.id;
			});
			if (nindex > -1) {
				nitems[nindex].loading = true;
			}

			return {
				...state,
				items: nitems,
				loading: false,
			};

		case 'GROUP_GET':
			const items = replaceOrAddById(
				[...state.items],
				action.payload.data.data
			);

			return {
				...state,
				items,
				loading: false,
			};

		default:
			return state;
	}
};
